export const UPDATE = 'UPDATE_WEBSOCKET_CONNECTIONSS';
